export default function nullAsDefault(object) {
  return Object.keys(object).reduce(
    (obj, key) => (object[key] === null ? obj : { ...obj, [key]: object[key] }),
    {}
  );
}
